const SettingsContentsTitle = ({ title }: { title: string }) => {
  return <h2 className="text-white text-[16px] font-medium leading-[1.5] select-none">{title}</h2>;
};

export default SettingsContentsTitle;
